import type { NamespaceCatalog } from '@/i18n/ns';

const workspaceShellCopy = {
  en: {
    dismissNavigation: 'Dismiss navigation',
    settingsNavigation: 'Settings navigation',
    workspaceNavigation: 'Workspace navigation',
    ponevaHome: 'Poneva home',
    expandNavigation: 'Expand navigation',
    collapseNavigation: 'Collapse navigation',
    closeNavigation: 'Close navigation',
    goBack: 'Go back',
    preferences: 'Preferences',
    companySettings: 'Company settings',
    workspace: 'Workspace',
    personal: 'Personal',
    settingsSections: 'Settings sections',
    workspaceSections: 'Workspace sections',
    yourAccount: 'Your account',
    recentChats: 'Recent chats',
    pickUp: 'Pick up where you left off',
    recentDescription: 'Your recent conversations',
    searchConversations: 'Search conversations',
    loadingChats: 'Loading conversations…',
    recentLoadFailed: 'Could not load recent conversations',
    noConversationMatch: 'No conversations match your search',
    firstMessage: 'Start a new conversation',
    agentRunsFooter: 'Agent runs',
    beingAnswered: 'Being answered',
    current: 'Current',
  },
  bg: {
    dismissNavigation: 'Затваряне на навигацията',
    settingsNavigation: 'Навигация в настройките',
    workspaceNavigation: 'Навигация в работното пространство',
    ponevaHome: 'Начало на Poneva',
    expandNavigation: 'Разгъване на навигацията',
    collapseNavigation: 'Свиване на навигацията',
    closeNavigation: 'Затваряне на навигацията',
    goBack: 'Назад',
    preferences: 'Предпочитания',
    companySettings: 'Настройки на компанията',
    workspace: 'Работно пространство',
    personal: 'Лични',
    settingsSections: 'Раздели на настройките',
    workspaceSections: 'Раздели на работното пространство',
    yourAccount: 'Вашият акаунт',
    recentChats: 'Последни разговори',
    pickUp: 'Продължете оттам, докъдето стигнахте',
    recentDescription: 'Последните ви разговори',
    searchConversations: 'Търсене в разговорите',
    loadingChats: 'Зареждане на разговорите…',
    recentLoadFailed: 'Последните разговори не можаха да бъдат заредени',
    noConversationMatch: 'Няма разговори, съответстващи на търсенето ви',
    firstMessage: 'Започнете нов разговор',
    agentRunsFooter: 'Изпълнения на агенти',
    beingAnswered: 'В процес на отговор',
    current: 'Текущо',
  },
  hr: {
    dismissNavigation: 'Sakrij navigaciju',
    settingsNavigation: 'Navigacija postavki',
    workspaceNavigation: 'Navigacija radnog prostora',
    ponevaHome: 'Početna Poneve',
    expandNavigation: 'Proširi navigaciju',
    collapseNavigation: 'Sažmi navigaciju',
    closeNavigation: 'Zatvori navigaciju',
    goBack: 'Natrag',
    preferences: 'Postavke',
    companySettings: 'Postavke tvrtke',
    workspace: 'Radni prostor',
    personal: 'Osobno',
    settingsSections: 'Odjeljci postavki',
    workspaceSections: 'Odjeljci radnog prostora',
    yourAccount: 'Vaš račun',
    recentChats: 'Nedavni razgovori',
    pickUp: 'Nastavite gdje ste stali',
    recentDescription: 'Vaši nedavni razgovori',
    searchConversations: 'Pretraži razgovore',
    loadingChats: 'Učitavanje razgovora…',
    recentLoadFailed: 'Nije moguće učitati nedavne razgovore',
    noConversationMatch: 'Nijedan razgovor ne odgovara vašem pretraživanju',
    firstMessage: 'Započni novi razgovor',
    agentRunsFooter: 'Pokretanja agenta',
    beingAnswered: 'Odgovaranje u tijeku',
    current: 'Trenutno',
  },
  cs: {
    dismissNavigation: 'Skrýt navigaci',
    settingsNavigation: 'Navigace nastavení',
    workspaceNavigation: 'Navigace pracovního prostoru',
    ponevaHome: 'Domovská stránka Poneva',
    expandNavigation: 'Rozbalit navigaci',
    collapseNavigation: 'Sbalit navigaci',
    closeNavigation: 'Zavřít navigaci',
    goBack: 'Zpět',
    preferences: 'Předvolby',
    companySettings: 'Nastavení společnosti',
    workspace: 'Pracovní prostor',
    personal: 'Osobní',
    settingsSections: 'Sekce nastavení',
    workspaceSections: 'Sekce pracovního prostoru',
    yourAccount: 'Váš účet',
    recentChats: 'Nedávné chaty',
    pickUp: 'Pokračujte tam, kde jste skončili',
    recentDescription: 'Vaše poslední konverzace',
    searchConversations: 'Hledat v konverzacích',
    loadingChats: 'Načítání konverzací…',
    recentLoadFailed: 'Nedávné konverzace se nepodařilo načíst',
    noConversationMatch: 'Žádné konverzace neodpovídají hledání',
    firstMessage: 'Zahájit novou konverzaci',
    agentRunsFooter: 'Spuštění agentů',
    beingAnswered: 'Probíhá odpověď',
    current: 'Aktuální',
  },
  da: {
    dismissNavigation: 'Luk navigationsmenuen',
    settingsNavigation: 'Navigation i indstillinger',
    workspaceNavigation: 'Navigation i arbejdsområde',
    ponevaHome: 'Poneva-startside',
    expandNavigation: 'Udvid navigationsmenuen',
    collapseNavigation: 'Skjul navigationsmenuen',
    closeNavigation: 'Luk navigationsmenuen',
    goBack: 'Gå tilbage',
    preferences: 'Præferencer',
    companySettings: 'Virksomhedsindstillinger',
    workspace: 'Arbejdsområde',
    personal: 'Personligt',
    settingsSections: 'Sektioner i indstillinger',
    workspaceSections: 'Sektioner i arbejdsområde',
    yourAccount: 'Din konto',
    recentChats: 'Seneste samtaler',
    pickUp: 'Fortsæt, hvor du slap',
    recentDescription: 'Dine seneste samtaler',
    searchConversations: 'Søg i samtaler',
    loadingChats: 'Indlæser samtaler…',
    recentLoadFailed: 'De seneste samtaler kunne ikke indlæses',
    noConversationMatch: 'Ingen samtaler matcher din søgning',
    firstMessage: 'Start en ny samtale',
    agentRunsFooter: 'Agentkørsler',
    beingAnswered: 'Besvares',
    current: 'Aktuel',
  },
  nl: {
    dismissNavigation: 'Navigatie sluiten',
    settingsNavigation: 'Navigatie door instellingen',
    workspaceNavigation: 'Navigatie door werkruimte',
    ponevaHome: 'Poneva-startpagina',
    expandNavigation: 'Navigatie uitvouwen',
    collapseNavigation: 'Navigatie inklappen',
    closeNavigation: 'Navigatie sluiten',
    goBack: 'Ga terug',
    preferences: 'Voorkeuren',
    companySettings: 'Bedrijfsinstellingen',
    workspace: 'Werkruimte',
    personal: 'Persoonlijk',
    settingsSections: 'Secties voor instellingen',
    workspaceSections: 'Secties voor werkruimte',
    yourAccount: 'Je account',
    recentChats: 'Recente chats',
    pickUp: 'Ga verder waar je gebleven was',
    recentDescription: 'Je recente gesprekken',
    searchConversations: 'Gesprekken zoeken',
    loadingChats: 'Gesprekken worden geladen…',
    recentLoadFailed: 'Recente gesprekken konden niet worden geladen',
    noConversationMatch: 'Geen gesprekken komen overeen met je zoekopdracht',
    firstMessage: 'Start een nieuw gesprek',
    agentRunsFooter: 'Agentuitvoeringen',
    beingAnswered: 'Wordt beantwoord',
    current: 'Huidig',
  },
  et: {
    dismissNavigation: 'Sulge navigeerimine',
    settingsNavigation: 'Seadete navigeerimine',
    workspaceNavigation: 'Tööruumi navigeerimine',
    ponevaHome: 'Poneva avaleht',
    expandNavigation: 'Laienda navigeerimist',
    collapseNavigation: 'Ahenda navigeerimine',
    closeNavigation: 'Sulge navigeerimine',
    goBack: 'Mine tagasi',
    preferences: 'Eelistused',
    companySettings: 'Ettevõtte seaded',
    workspace: 'Tööruum',
    personal: 'Isiklik',
    settingsSections: 'Seadete jaotised',
    workspaceSections: 'Tööruumi jaotised',
    yourAccount: 'Sinu konto',
    recentChats: 'Hiljutised vestlused',
    pickUp: 'Jätka pooleli jäänud kohast',
    recentDescription: 'Sinu hiljutised vestlused',
    searchConversations: 'Otsi vestlusi',
    loadingChats: 'Vestluste laadimine…',
    recentLoadFailed: 'Hiljutisi vestlusi ei saanud laadida',
    noConversationMatch: 'Otsingule vastavaid vestlusi ei leitud',
    firstMessage: 'Alusta uut vestlust',
    agentRunsFooter: 'Agendi käitamised',
    beingAnswered: 'Vastamisel',
    current: 'Praegune',
  },
  fi: {
    dismissNavigation: 'Sulje navigointi',
    settingsNavigation: 'Asetusten navigointi',
    workspaceNavigation: 'Työtilan navigointi',
    ponevaHome: 'Ponevan etusivu',
    expandNavigation: 'Laajenna navigointia',
    collapseNavigation: 'Kutista navigointi',
    closeNavigation: 'Sulje navigointi',
    goBack: 'Palaa takaisin',
    preferences: 'Asetukset',
    companySettings: 'Yrityksen asetukset',
    workspace: 'Työtila',
    personal: 'Henkilökohtainen',
    settingsSections: 'Asetusten osiot',
    workspaceSections: 'Työtilan osiot',
    yourAccount: 'Tilisi',
    recentChats: 'Viimeisimmät keskustelut',
    pickUp: 'Jatka siitä, mihin jäit',
    recentDescription: 'Viimeisimmät keskustelusi',
    searchConversations: 'Hae keskusteluista',
    loadingChats: 'Ladataan keskusteluja…',
    recentLoadFailed: 'Viimeisimpiä keskusteluja ei voitu ladata',
    noConversationMatch: 'Hakusi ei vastaa keskusteluja',
    firstMessage: 'Aloita uusi keskustelu',
    agentRunsFooter: 'Agenttien suoritukset',
    beingAnswered: 'Vastausta laaditaan',
    current: 'Nykyinen',
  },
  fr: {
    dismissNavigation: 'Fermer la navigation',
    settingsNavigation: 'Navigation des paramètres',
    workspaceNavigation: 'Navigation de l’espace de travail',
    ponevaHome: 'Accueil Poneva',
    expandNavigation: 'Développer la navigation',
    collapseNavigation: 'Réduire la navigation',
    closeNavigation: 'Fermer la navigation',
    goBack: 'Retour',
    preferences: 'Préférences',
    companySettings: 'Paramètres de l’entreprise',
    workspace: 'Espace de travail',
    personal: 'Personnel',
    settingsSections: 'Sections des paramètres',
    workspaceSections: 'Sections de l’espace de travail',
    yourAccount: 'Votre compte',
    recentChats: 'Conversations récentes',
    pickUp: 'Reprendre là où vous vous êtes arrêté',
    recentDescription: 'Vos conversations récentes',
    searchConversations: 'Rechercher dans les conversations',
    loadingChats: 'Chargement des conversations…',
    recentLoadFailed: 'Impossible de charger les conversations récentes',
    noConversationMatch: 'Aucune conversation ne correspond à votre recherche',
    firstMessage: 'Démarrer une nouvelle conversation',
    agentRunsFooter: 'Exécutions d’agent',
    beingAnswered: 'Réponse en cours',
    current: 'Actuel',
  },
  de: {
    dismissNavigation: 'Navigation schließen',
    settingsNavigation: 'Einstellungsnavigation',
    workspaceNavigation: 'Arbeitsbereichsnavigation',
    ponevaHome: 'Poneva-Startseite',
    expandNavigation: 'Navigation erweitern',
    collapseNavigation: 'Navigation reduzieren',
    closeNavigation: 'Navigation schließen',
    goBack: 'Zurück',
    preferences: 'Einstellungen',
    companySettings: 'Unternehmenseinstellungen',
    workspace: 'Arbeitsbereich',
    personal: 'Persönlich',
    settingsSections: 'Einstellungsbereiche',
    workspaceSections: 'Arbeitsbereichsbereiche',
    yourAccount: 'Ihr Konto',
    recentChats: 'Letzte Chats',
    pickUp: 'Dort weitermachen, wo Sie aufgehört haben',
    recentDescription: 'Ihre letzten Unterhaltungen',
    searchConversations: 'Unterhaltungen durchsuchen',
    loadingChats: 'Unterhaltungen werden geladen…',
    recentLoadFailed: 'Letzte Unterhaltungen konnten nicht geladen werden',
    noConversationMatch: 'Keine Unterhaltungen entsprechen Ihrer Suche',
    firstMessage: 'Neue Unterhaltung starten',
    agentRunsFooter: 'Agent-Ausführungen',
    beingAnswered: 'Wird beantwortet',
    current: 'Aktuell',
  },
  el: {
    dismissNavigation: 'Απόκρυψη πλοήγησης',
    settingsNavigation: 'Πλοήγηση στις ρυθμίσεις',
    workspaceNavigation: 'Πλοήγηση στον χώρο εργασίας',
    ponevaHome: 'Αρχική σελίδα Poneva',
    expandNavigation: 'Ανάπτυξη πλοήγησης',
    collapseNavigation: 'Σύμπτυξη πλοήγησης',
    closeNavigation: 'Κλείσιμο πλοήγησης',
    goBack: 'Πίσω',
    preferences: 'Προτιμήσεις',
    companySettings: 'Ρυθμίσεις εταιρείας',
    workspace: 'Χώρος εργασίας',
    personal: 'Προσωπικά',
    settingsSections: 'Ενότητες ρυθμίσεων',
    workspaceSections: 'Ενότητες χώρου εργασίας',
    yourAccount: 'Ο λογαριασμός σας',
    recentChats: 'Πρόσφατες συνομιλίες',
    pickUp: 'Συνεχίστε από εκεί που σταματήσατε',
    recentDescription: 'Οι πρόσφατες συνομιλίες σας',
    searchConversations: 'Αναζήτηση συνομιλιών',
    loadingChats: 'Φόρτωση συνομιλιών…',
    recentLoadFailed: 'Δεν ήταν δυνατή η φόρτωση των πρόσφατων συνομιλιών',
    noConversationMatch: 'Δεν υπάρχουν συνομιλίες που να ταιριάζουν με την αναζήτησή σας',
    firstMessage: 'Ξεκινήστε μια νέα συνομιλία',
    agentRunsFooter: 'Εκτελέσεις agent',
    beingAnswered: 'Απαντάται',
    current: 'Τρέχον',
  },
  hu: {
    dismissNavigation: 'Navigáció bezárása',
    settingsNavigation: 'Beállítások navigációja',
    workspaceNavigation: 'Munkaterület navigációja',
    ponevaHome: 'Poneva kezdőlapja',
    expandNavigation: 'Navigáció kibontása',
    collapseNavigation: 'Navigáció összecsukása',
    closeNavigation: 'Navigáció bezárása',
    goBack: 'Vissza',
    preferences: 'Beállítások',
    companySettings: 'Céges beállítások',
    workspace: 'Munkaterület',
    personal: 'Személyes',
    settingsSections: 'Beállítási szakaszok',
    workspaceSections: 'Munkaterület-szakaszok',
    yourAccount: 'Fiókod',
    recentChats: 'Legutóbbi csevegések',
    pickUp: 'Folytasd ott, ahol abbahagytad',
    recentDescription: 'Legutóbbi beszélgetéseid',
    searchConversations: 'Beszélgetések keresése',
    loadingChats: 'Beszélgetések betöltése…',
    recentLoadFailed: 'Nem sikerült betölteni a legutóbbi beszélgetéseket',
    noConversationMatch: 'Nincs a keresésnek megfelelő beszélgetés',
    firstMessage: 'Új beszélgetés indítása',
    agentRunsFooter: 'Ügynökfuttatások',
    beingAnswered: 'Megválaszolás alatt',
    current: 'Jelenlegi',
  },
  ga: {
    dismissNavigation: 'Dún an nascleanúint',
    settingsNavigation: 'Nascleanúint na socruithe',
    workspaceNavigation: 'Nascleanúint an spáis oibre',
    ponevaHome: 'Leathanach baile Poneva',
    expandNavigation: 'Leathnaigh an nascleanúint',
    collapseNavigation: 'Laghdaigh an nascleanúint',
    closeNavigation: 'Dún an nascleanúint',
    goBack: 'Téigh siar',
    preferences: 'Sainroghanna',
    companySettings: 'Socruithe na cuideachta',
    workspace: 'Spás oibre',
    personal: 'Pearsanta',
    settingsSections: 'Rannóga na socruithe',
    workspaceSections: 'Rannóga an spáis oibre',
    yourAccount: 'Do chuntas',
    recentChats: 'Comhráite le déanaí',
    pickUp: 'Lean ar aghaidh ón áit ar fhág tú é',
    recentDescription: 'Do chomhráite le déanaí',
    searchConversations: 'Cuardaigh comhráite',
    loadingChats: 'Comhráite á lódáil…',
    recentLoadFailed: 'Níorbh fhéidir comhráite le déanaí a luchtú',
    noConversationMatch: 'Níor aimsíodh aon chomhrá a mheaitseálann do chuardach',
    firstMessage: 'Cuir tús le comhrá nua',
    agentRunsFooter: 'Ritheanna gníomhairí',
    beingAnswered: 'Á fhreagairt',
    current: 'Reatha',
  },
  it: {
    dismissNavigation: 'Chiudi navigazione',
    settingsNavigation: 'Navigazione delle impostazioni',
    workspaceNavigation: "Navigazione dell'area di lavoro",
    ponevaHome: 'Home di Poneva',
    expandNavigation: 'Espandi navigazione',
    collapseNavigation: 'Comprimi navigazione',
    closeNavigation: 'Chiudi navigazione',
    goBack: 'Torna indietro',
    preferences: 'Preferenze',
    companySettings: 'Impostazioni aziendali',
    workspace: 'Area di lavoro',
    personal: 'Personale',
    settingsSections: 'Sezioni delle impostazioni',
    workspaceSections: "Sezioni dell'area di lavoro",
    yourAccount: 'Il tuo account',
    recentChats: 'Chat recenti',
    pickUp: 'Riprendi da dove avevi interrotto',
    recentDescription: 'Le tue conversazioni recenti',
    searchConversations: 'Cerca conversazioni',
    loadingChats: 'Caricamento delle conversazioni…',
    recentLoadFailed: 'Impossibile caricare le conversazioni recenti',
    noConversationMatch: 'Nessuna conversazione corrisponde alla tua ricerca',
    firstMessage: 'Inizia una nuova conversazione',
    agentRunsFooter: "Esecuzioni dell'agente",
    beingAnswered: 'In attesa di risposta',
    current: 'Attuale',
  },
  lv: {
    dismissNavigation: 'Aizvērt navigāciju',
    settingsNavigation: 'Iestatījumu navigācija',
    workspaceNavigation: 'Darbvietas navigācija',
    ponevaHome: 'Poneva sākumlapa',
    expandNavigation: 'Izvērst navigāciju',
    collapseNavigation: 'Sakļaut navigāciju',
    closeNavigation: 'Aizvērt navigāciju',
    goBack: 'Atgriezties',
    companySettings: 'Uzņēmuma iestatījumi',
    workspace: 'Darbvieta',
    personal: 'Personīgais',
    settingsSections: 'Iestatījumu sadaļas',
    workspaceSections: 'Darbvietas sadaļas',
    yourAccount: 'Jūsu konts',
    recentChats: 'Nesenās tērzēšanas',
    pickUp: 'Turpiniet no vietas, kur pārtraucāt',
    recentDescription: 'Jūsu nesenās sarunas',
    searchConversations: 'Meklēt sarunas',
    loadingChats: 'Notiek sarunu ielāde…',
    recentLoadFailed: 'Neizdevās ielādēt nesenās sarunas',
    noConversationMatch: 'Neviena saruna neatbilst jūsu meklējumam',
    firstMessage: 'Sākt jaunu sarunu',
    agentRunsFooter: 'Aģentu izpildes',
    beingAnswered: 'Notiek atbildēšana',
    current: 'Pašreizējā',
    preferences: 'Iestatījumi',
  },
  lt: {
    dismissNavigation: 'Atmesti navigaciją',
    settingsNavigation: 'Nustatymų navigacija',
    workspaceNavigation: 'Darbo srities navigacija',
    ponevaHome: 'Poneva pradinis puslapis',
    expandNavigation: 'Išplėsti navigaciją',
    collapseNavigation: 'Sutraukti navigaciją',
    closeNavigation: 'Uždaryti navigaciją',
    goBack: 'Grįžti',
    preferences: 'Nuostatos',
    companySettings: 'Įmonės nustatymai',
    workspace: 'Darbo sritis',
    personal: 'Asmeninis',
    settingsSections: 'Nustatymų skyriai',
    workspaceSections: 'Darbo srities skyriai',
    yourAccount: 'Jūsų paskyra',
    recentChats: 'Naujausi pokalbiai',
    pickUp: 'Tęskite nuo ten, kur baigėte',
    recentDescription: 'Jūsų naujausi pokalbiai',
    searchConversations: 'Ieškoti pokalbių',
    loadingChats: 'Įkeliami pokalbiai…',
    recentLoadFailed: 'Nepavyko įkelti naujausių pokalbių',
    noConversationMatch: 'Nė vienas pokalbis neatitinka paieškos',
    firstMessage: 'Pradėti naują pokalbį',
    agentRunsFooter: 'Agentų vykdymai',
    beingAnswered: 'Atsakoma',
    current: 'Dabartinis',
  },
  mt: {
    dismissNavigation: 'Agħlaq in-navigazzjoni',
    settingsNavigation: 'Navigazzjoni tas-settings',
    workspaceNavigation: 'Navigazzjoni tal-ispazju tax-xogħol',
    ponevaHome: "Paġna ewlenija ta' Poneva",
    expandNavigation: 'Espandi n-navigazzjoni',
    collapseNavigation: 'Ikkollassa n-navigazzjoni',
    closeNavigation: 'Agħlaq in-navigazzjoni',
    goBack: 'Mur lura',
    preferences: 'Preferenzi',
    companySettings: 'Settings tal-kumpanija',
    workspace: 'Spazju tax-xogħol',
    personal: 'Personali',
    settingsSections: 'Sezzjonijiet tas-settings',
    workspaceSections: 'Sezzjonijiet tal-ispazju tax-xogħol',
    yourAccount: 'Il-kont tiegħek',
    recentChats: 'Chats reċenti',
    pickUp: 'Kompli minn fejn ħallejt',
    recentDescription: 'Il-konversazzjonijiet reċenti tiegħek',
    searchConversations: 'Fittex konversazzjonijiet',
    loadingChats: 'Qed jitgħabbew il-konversazzjonijiet…',
    recentLoadFailed: 'Ma setgħux jitgħabbew il-konversazzjonijiet reċenti',
    noConversationMatch: 'L-ebda konversazzjoni ma taqbel mat-tfittxija tiegħek',
    firstMessage: 'Ibda konversazzjoni ġdida',
    agentRunsFooter: 'Eżekuzzjonijiet tal-aġent',
    beingAnswered: 'Qed tingħata tweġiba',
    current: 'Kurrenti',
  },
  pl: {
    dismissNavigation: 'Zamknij nawigację',
    settingsNavigation: 'Nawigacja ustawień',
    workspaceNavigation: 'Nawigacja obszaru roboczego',
    ponevaHome: 'Strona główna Poneva',
    expandNavigation: 'Rozwiń nawigację',
    collapseNavigation: 'Zwiń nawigację',
    closeNavigation: 'Zamknij nawigację',
    goBack: 'Wróć',
    preferences: 'Preferencje',
    companySettings: 'Ustawienia firmy',
    workspace: 'Obszar roboczy',
    personal: 'Osobiste',
    settingsSections: 'Sekcje ustawień',
    workspaceSections: 'Sekcje obszaru roboczego',
    yourAccount: 'Twoje konto',
    recentChats: 'Ostatnie czaty',
    pickUp: 'Kontynuuj od miejsca, w którym przerwano',
    recentDescription: 'Twoje ostatnie rozmowy',
    searchConversations: 'Szukaj rozmów',
    loadingChats: 'Ładowanie rozmów…',
    recentLoadFailed: 'Nie udało się wczytać ostatnich rozmów',
    noConversationMatch: 'Brak rozmów pasujących do wyszukiwania',
    firstMessage: 'Rozpocznij nową rozmowę',
    agentRunsFooter: 'Uruchomienia agentów',
    beingAnswered: 'Trwa udzielanie odpowiedzi',
    current: 'Bieżące',
  },
  pt: {
    dismissNavigation: 'Dispensar navegação',
    settingsNavigation: 'Navegação das configurações',
    workspaceNavigation: 'Navegação do espaço de trabalho',
    ponevaHome: 'Página inicial do Poneva',
    expandNavigation: 'Expandir navegação',
    collapseNavigation: 'Recolher navegação',
    closeNavigation: 'Fechar navegação',
    goBack: 'Voltar',
    preferences: 'Preferências',
    companySettings: 'Configurações da empresa',
    workspace: 'Espaço de trabalho',
    personal: 'Pessoal',
    settingsSections: 'Seções de configurações',
    workspaceSections: 'Seções do espaço de trabalho',
    yourAccount: 'Sua conta',
    recentChats: 'Conversas recentes',
    pickUp: 'Retome de onde parou',
    recentDescription: 'Suas conversas recentes',
    searchConversations: 'Pesquisar conversas',
    loadingChats: 'Carregando conversas…',
    recentLoadFailed: 'Não foi possível carregar as conversas recentes',
    noConversationMatch: 'Nenhuma conversa corresponde à sua pesquisa',
    firstMessage: 'Iniciar uma nova conversa',
    agentRunsFooter: 'Execuções do agente',
    beingAnswered: 'Sendo respondida',
    current: 'Atual',
  },
  ro: {
    dismissNavigation: 'Închide navigarea',
    settingsNavigation: 'Navigarea setărilor',
    workspaceNavigation: 'Navigarea spațiului de lucru',
    ponevaHome: 'Pagina principală Poneva',
    expandNavigation: 'Extinde navigarea',
    collapseNavigation: 'Restrânge navigarea',
    closeNavigation: 'Închide navigarea',
    goBack: 'Înapoi',
    preferences: 'Preferințe',
    companySettings: 'Setările companiei',
    workspace: 'Spațiu de lucru',
    personal: 'Personal',
    settingsSections: 'Secțiunile setărilor',
    workspaceSections: 'Secțiunile spațiului de lucru',
    yourAccount: 'Contul tău',
    recentChats: 'Conversații recente',
    pickUp: 'Continuă de unde ai rămas',
    recentDescription: 'Conversațiile tale recente',
    searchConversations: 'Caută conversații',
    loadingChats: 'Se încarcă conversațiile…',
    recentLoadFailed: 'Conversațiile recente nu au putut fi încărcate',
    noConversationMatch: 'Nicio conversație nu corespunde căutării',
    firstMessage: 'Începe o conversație nouă',
    agentRunsFooter: 'Execuții ale agenților',
    beingAnswered: 'Se răspunde',
    current: 'Curent',
  },
  sk: {
    dismissNavigation: 'Skryť navigáciu',
    settingsNavigation: 'Navigácia nastavení',
    workspaceNavigation: 'Navigácia pracovného priestoru',
    ponevaHome: 'Domov Poneva',
    expandNavigation: 'Rozbaliť navigáciu',
    collapseNavigation: 'Zbaliť navigáciu',
    closeNavigation: 'Zavrieť navigáciu',
    goBack: 'Späť',
    preferences: 'Predvoľby',
    companySettings: 'Nastavenia spoločnosti',
    workspace: 'Pracovný priestor',
    personal: 'Osobné',
    settingsSections: 'Sekcie nastavení',
    workspaceSections: 'Sekcie pracovného priestoru',
    yourAccount: 'Váš účet',
    recentChats: 'Nedávne chaty',
    pickUp: 'Pokračujte tam, kde ste skončili',
    recentDescription: 'Vaše nedávne konverzácie',
    searchConversations: 'Vyhľadať konverzácie',
    loadingChats: 'Načítavajú sa konverzácie…',
    recentLoadFailed: 'Nepodarilo sa načítať nedávne konverzácie',
    noConversationMatch: 'Vyhľadávaniu nezodpovedajú žiadne konverzácie',
    firstMessage: 'Začať novú konverzáciu',
    agentRunsFooter: 'Spustenia agentov',
    beingAnswered: 'Prebieha odpovedanie',
    current: 'Aktuálne',
  },
  sl: {
    dismissNavigation: 'Skrij navigacijo',
    settingsNavigation: 'Navigacija po nastavitvah',
    workspaceNavigation: 'Navigacija po delovnem prostoru',
    ponevaHome: 'Začetna stran Poneva',
    expandNavigation: 'Razširi navigacijo',
    collapseNavigation: 'Strni navigacijo',
    closeNavigation: 'Zapri navigacijo',
    goBack: 'Nazaj',
    preferences: 'Nastavitve',
    companySettings: 'Nastavitve podjetja',
    workspace: 'Delovni prostor',
    personal: 'Osebno',
    settingsSections: 'Razdelki nastavitev',
    workspaceSections: 'Razdelki delovnega prostora',
    yourAccount: 'Vaš račun',
    recentChats: 'Nedavni klepeti',
    pickUp: 'Nadaljujte, kjer ste končali',
    recentDescription: 'Vaši nedavni pogovori',
    searchConversations: 'Iskanje pogovorov',
    loadingChats: 'Nalaganje pogovorov…',
    recentLoadFailed: 'Nedavnih pogovorov ni bilo mogoče naložiti',
    noConversationMatch: 'Iskanju ne ustreza noben pogovor',
    firstMessage: 'Začnite nov pogovor',
    agentRunsFooter: 'Izvajanja agenta',
    beingAnswered: 'Odgovarjanje v teku',
    current: 'Trenutno',
  },
  es: {
    dismissNavigation: 'Descartar navegación',
    settingsNavigation: 'Navegación de configuración',
    workspaceNavigation: 'Navegación del espacio de trabajo',
    ponevaHome: 'Inicio de Poneva',
    expandNavigation: 'Expandir navegación',
    collapseNavigation: 'Contraer navegación',
    closeNavigation: 'Cerrar navegación',
    goBack: 'Volver',
    preferences: 'Preferencias',
    companySettings: 'Configuración de la empresa',
    workspace: 'Espacio de trabajo',
    personal: 'Personal',
    settingsSections: 'Secciones de configuración',
    workspaceSections: 'Secciones del espacio de trabajo',
    yourAccount: 'Tu cuenta',
    recentChats: 'Conversaciones recientes',
    pickUp: 'Retoma donde lo dejaste',
    recentDescription: 'Tus conversaciones recientes',
    searchConversations: 'Buscar conversaciones',
    loadingChats: 'Cargando conversaciones…',
    recentLoadFailed: 'No se pudieron cargar las conversaciones recientes',
    noConversationMatch: 'Ninguna conversación coincide con tu búsqueda',
    firstMessage: 'Iniciar una conversación nueva',
    agentRunsFooter: 'Ejecuciones del agente',
    beingAnswered: 'Se está respondiendo',
    current: 'Actual',
  },
  sv: {
    dismissNavigation: 'Dölj navigering',
    settingsNavigation: 'Navigering för inställningar',
    workspaceNavigation: 'Navigering i arbetsyta',
    ponevaHome: 'Poneva-startsida',
    expandNavigation: 'Expandera navigering',
    collapseNavigation: 'Fäll ihop navigering',
    closeNavigation: 'Stäng navigering',
    goBack: 'Gå tillbaka',
    preferences: 'Inställningar',
    companySettings: 'Företagsinställningar',
    workspace: 'Arbetsyta',
    personal: 'Personligt',
    settingsSections: 'Inställningsavsnitt',
    workspaceSections: 'Arbetsyteavsnitt',
    yourAccount: 'Ditt konto',
    recentChats: 'Senaste chattarna',
    pickUp: 'Fortsätt där du slutade',
    recentDescription: 'Dina senaste konversationer',
    searchConversations: 'Sök i konversationer',
    loadingChats: 'Läser in konversationer…',
    recentLoadFailed: 'Det gick inte att läsa in de senaste konversationerna',
    noConversationMatch: 'Inga konversationer matchar din sökning',
    firstMessage: 'Starta en ny konversation',
    agentRunsFooter: 'Agentkörningar',
    beingAnswered: 'Besvaras',
    current: 'Aktuell',
  },
} as const;

export type WorkspaceShellCopyKey = keyof typeof workspaceShellCopy.en;
export default workspaceShellCopy as unknown as NamespaceCatalog<WorkspaceShellCopyKey>;
